const IconMixin = {
  props: {
    name: {
      type: String,
      required: true,
    },
    color: {
      type: String,
    },
    size: {
      type: [String, Number],
      default: '1em',
    },
  },
};

export default IconMixin;
